import PropTypes from "prop-types";
// import { navigate } from "gatsby";
import React, { useRef, useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";

// Components
import Layout from "../components/Layout";
import Link from "../components/Link";
import SEO from "../components/SEO";
import ReadyToGetStarted from "../components/ReadyToGetStarted";

// HOC
import withLazy from "../hocs/WithLazy";

// Partials
import ClientLogos from "../partials/home/ClientLogos";
import FeaturesSection from "../partials/home/FeaturesSection";

// Content
import faqData from "../content/home";

// Constants
import { CASHFREE_DOC_OVER_VIEW, WEBSITE_ASSETS_URL } from "../constants/Url";
import {
  // FETCH_REGION_API_URL,
  MERCHANT_DASHBOARD_SIGNUP_URL,
} from "../constants/env";

// import { makeRequest } from "../api";
// import { allowedLanguages } from "../constants/languages";

import { clientLogos, enterprisesData, quotes } from "../constants/home";

import PartnerThoughts from "../partials/home/PartnerThoughts";
import useMediaQuery from "../hooks/useMediaQuery";

// Lazy Load

const AsyncFAQ = withLazy(() => import("../components/FAQSection"));
const AsyncEnterprises = withLazy(() => import("../partials/home/Enterprises"));
const DevelopersSection = withLazy(() =>
  import("../partials/home/DevelopersSection"),
);

const Homepage = ({ lottie, ...rest }) => {
  // const { i18n } = useTranslation();

  const featuresRef = useRef();
  const testimonialIntervals = useRef([]);

  const [testimonialSlide, settestimonialSlide] = useState(0);
  const isMobile = useMediaQuery("(max-width: 1024px)");

  // const getRegion = async () => {
  //   try {
  //     const response = await makeRequest.get(
  //       `${FETCH_REGION_API_URL}?format=json`,
  //     );
  //     const data = await response.data;
  //     if (
  //       data.countryCode &&
  //       data.countryCode in allowedLanguages &&
  //       allowedLanguages[data.countryCode] !== i18n.language
  //     ) {
  //       const updatedLanguage = allowedLanguages[data.countryCode];
  //       i18n.changeLanguage(updatedLanguage);
  //       navigate(`/${allowedLanguages[data.countryCode]}`);
  //     }
  //   } catch (error) {
  //     console.error("Error in getRegion:", error);
  //   }
  // };

  useEffect(() => {
    // const fetchAndNavigate = async () => {
    //   await getRegion();
    // };
    // fetchAndNavigate();

    settestimonialSlide(0);
    const interval = window.setInterval(() => {
      settestimonialSlide((state) => (state === 2 ? 0 : state + 1));
    }, 4000);

    testimonialIntervals.current.push(interval);
    return () => clearInterval(interval);
  }, []);

  return (
    <Layout {...rest}>
      <SEO
        title="Cashfree Payments - Complete Payment and Banking Platform for India"
        description="Built for your business payment needs - Collect payments, send payouts, manage international payments, launch your next neo banking product and do a lot more."
        url="https://www.cashfree.com/"
        keywords={[]}
      />
      <section className="index-hero-heroBanner bg-cover bg-no-repeat relative">
        <picture className="absolute inset-0 w-full h-full">
          {/* For large desktop screens */}
          <source
            type="image/webp"
            media="(min-width: 1200px)"
            srcSet={`${WEBSITE_ASSETS_URL}/landings-cache/landings/homepage/bg_2x_desktop.webp`}
          />
          {/* For tablets */}
          <source
            type="image/webp"
            media="(min-width: 768px) and (max-width: 1199px)"
            srcSet={`${WEBSITE_ASSETS_URL}/landings-cache/landings/homepage/background-m_2x.webp`}
          />
          {/* For mobile */}
          <source
            type="image/webp"
            media="(max-width: 767px)"
            srcSet={`${WEBSITE_ASSETS_URL}/landings-cache/landings/homepage/background-m_2x.webp`}
          />
          {/* Fallback image */}
          <img
            src={`${WEBSITE_ASSETS_URL}/landings-cache/landings/homepage}/bg_3x_desktop.webp`}
            alt="Cashfree Hero Banner"
            className="w-full h-full object-cover block"
            loading="lazy"
          />
        </picture>

        <div className="container index-hero-container relative">
          <div className="row mobile-wrap tablet-wrap">
            <div className="column">
              <div className="index-hero-content greater_than_md:mt-[2rem]">
                <div className="md:text-[48px] sm:text-[36px] text-[#240253] font-inter text-[28px] font-extrabold leading-[36px] sm:leading-[42px] md:leading-[58px]">
                  <div>A Payment Gateway Faster in Every Way</div>
                </div>
                <div>
                  <p
                    className="ml-[2px] !mt-4 md:ml-1 text-[#666]"
                    style={{ maxWidth: 512 }}>
                    Faster Onboarding • Faster Payments • Faster Support
                  </p>
                </div>

                {!isMobile && (
                  <div className="flex flex-wrap flex-col md:flex-row md:flex-nowrap md:justify-start cnt-buttons-hero">
                    <a
                      className="button button-purple w-full md:w-auto md:mr-4 !rounded-[6px]"
                      href={`${MERCHANT_DASHBOARD_SIGNUP_URL}?source-action=Home%20page&action=Sign%20Up&button-id=StartNow_Hero`}>
                      Create Account <span className="chevron" />
                    </a>
                    <Link
                      className="button !bg-transparent !border !border-[#6933d3] !text-[#6933d3] w-full md:w-auto mt-4 md:mt-0 !rounded-[6px]"
                      to="/contact-sales/?source-action=Home%20page&action=Contact%20Sales&button-id=ContactSales_Hero">
                      Contact Sales{" "}
                      <span className="chevron" style={{ color: "#6933d3" }} />
                    </Link>
                  </div>
                )}

                <div className="row align-flex-start justify-flex-start hero-stats-hero max-w-full w-full">
                  <div className="pr-5md md:pr-6md md:mr-[1rem]">
                    <h3 className="body-font between-md-and-xl:!text-[15px]">
                      8,00,000+
                    </h3>
                    <p>Businesses served</p>
                  </div>
                  <div className="px-5md md:px-6md md:mr-[1rem]">
                    <h3 className="body-font whitespace-nowrap md:whitespace-normal between-md-and-xl:!text-[15px]">
                      USD 80B+
                    </h3>
                    <p>Processed annually</p>
                  </div>
                  <div className="pl-5md md:pl-6md">
                    <h3 className="body-font between-md-and-xl:!text-[15px]">
                      600M+
                    </h3>
                    <p>Bank accounts served</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="hero-image-styling w-full lg:max-w-[750px] flex align-center lg:min-h-[680px]">
              <div style={{ width: "inherit" }}>
                <picture
                  style={{ width: "100%", height: "auto", display: "block" }}>
                  {/* For large desktop screens */}
                  <source
                    media="(min-width: 1200px)"
                    srcSet={`${WEBSITE_ASSETS_URL}/landings-cache/landings/homepage/rkr_2x_Desktop_1.webp`}
                  />

                  {/* For tablets (medium-sized devices) */}
                  <source
                    media="(min-width: 768px) and (max-width: 1199px)"
                    srcSet={`${WEBSITE_ASSETS_URL}/landings-cache/landings/homepage/rkr_1x_mobile_1.webp`}
                  />

                  {/* For small devices (mobile) */}
                  <source
                    media="(max-width: 767px)"
                    srcSet={`${WEBSITE_ASSETS_URL}/landings-cache/landings/homepage/rkr_1x_mobile_1.webp`}
                  />

                  {/* Fallback image */}
                  <img
                    src={`${WEBSITE_ASSETS_URL}/landings-cache/landings/homepage/rkr_2x_Desktop_3.webp`}
                    alt="Cashfree Logo"
                    className="w-full h-auto object-cover block"
                    loading="eager"
                  />
                </picture>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="client-logos">
            <ClientLogos clientLogos={clientLogos} />
          </div>
        </div>
      </section>
      <section ref={featuresRef}>
        <FeaturesSection />
      </section>

      <PartnerThoughts quotes={quotes} testimonialSlide={testimonialSlide} />

      <section
        className="section-padding index-section-2 overflow-hidden"
        style={{ padding: "4rem 0px 10rem", backgroundColor: "#F6F6FE" }}>
        <div className="container ">
          <AsyncEnterprises enterprisesData={enterprisesData} />
        </div>
      </section>
      <DevelopersSection />
      <div className="container general-faqs">
        <AsyncFAQ
          open="0"
          data={faqData}
          supportLinkHref={CASHFREE_DOC_OVER_VIEW}
        />
      </div>
      <ReadyToGetStarted utmSourceAction="source-action=Home%20page" />
    </Layout>
  );
};

Homepage.defaultProps = {
  lottie: null,
};

Homepage.propTypes = {
  lottie: PropTypes.shape({}),
};

export default Homepage;
